<script>
import dashboardNumberFormat from '../mixins/dashboardNumberFormat';

export default {
    name: 'KpiScalarBox',
    mixins: [dashboardNumberFormat],
    props: {
        value: {
            type: [Number, String],
            default: 0,
        },
        label: {
            type: String,
            default: '',
        },
        metricKey: {
            type: String,
            default: '',
        },
        boxColor: {
            type: String,
            default: 'bg-purple',
        },
        icon: {
            type: String,
            default: 'fa-line-chart',
        },
    },
};
</script>

<template>
    <div class="kpi-scalar-box small-box" :class="boxColor">
        <div class="inner">
            <h3>{{ formatKpiValue(value, metricKey) }}</h3>
            <p>{{ label }}</p>
        </div>
        <div class="icon">
            <i class="fa" :class="icon" />
        </div>
    </div>
</template>
